import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/auth';



export const PublicRoute = ({ children }) => {

    const { token } = useContext( AuthContext );
    
    return (!token)
        ? children
        : <Navigate to="/" />
}